import FilesDropArea from "@entrilia/shared/components/FilesDropArea";
import { formatFileSize } from "@entrilia/shared/utilities/fileHelper";
import { fileToUploadValidator } from "@entrilia/shared/utilities/validators";
import { useImportCsvDataContext } from "../ImportCsvDataContext";
import { addInvalidFileAction, startFileUploadAction } from "../importCsvDataPageState";

const maxFileSize = 100_000_000; // 100 MB
const acceptedFileExtensions = [".csv"];
const subtitle = `Maximum file size: ${formatFileSize(maxFileSize)}. Supported format: csv.`;

const fileValidator = fileToUploadValidator({ maxFileSize, acceptedFileExtensions });

interface Props {
  targetOptionKey: string;
  onUploadStart: (targetOptionKey: string, file: File) => void;
}

const ImportSourceFileUploadArea = ({ targetOptionKey, onUploadStart }: Props) => {
  const { setPageState } = useImportCsvDataContext();

  const handleFilesAdd = (files: File[]) => {
    const file = files[0];
    if (!file) {
      return;
    }

    const validationResult = fileValidator(file);
    if (validationResult.isValid) {
      setPageState(startFileUploadAction(targetOptionKey, file.name, file.size));
      onUploadStart(targetOptionKey, file);
    } else {
      setPageState(addInvalidFileAction(targetOptionKey, file.name, file.size, validationResult.error));
    }
  };

  return (
    <FilesDropArea acceptedFileExtensions={acceptedFileExtensions} subtitle={subtitle} onFilesAdd={handleFilesAdd} />
  );
};

export default ImportSourceFileUploadArea;
